export default __webpack_public_path__ + "static/media/gif15.b5f7ad29.gif";